import { registerMockAPI } from '~/mocks/mockApis';

import { axiosInstance } from '~/services';

import type { TypeGetOwnerSupplierParams, TypeGetOwnerSupplierResponse } from '~/types/vender.types';

/**
 * [화주사정보관리 > 공급사관리] 공급사 목록 조회
 */
const useGetOwnerSupplier = () => {
  const endPoint = '/api-owner/owner-supplier';

  const getOwnerSupplier = async (params: TypeGetOwnerSupplierParams) => {
    return axiosInstance
      .get<TypeGetOwnerSupplierResponse>(endPoint, { params })
      .then((data) => {
        return data.data;
      })
      .catch((error) => {
        throw error;
      });
  };

  return { getOwnerSupplier };
};

export default useGetOwnerSupplier;

const ownerSupplierListResponse: TypeGetOwnerSupplierResponse = {
  pagination: { cursor: 1, listView: 50, listTotal: 5 },
  data: [
    {
      ownerSupplierId: 5,
      ownerSupplierName: '[e2e] 신선농산 주식회사',
      ownerSupplierCode: 'SU000005',
      createdAt: '2026-05-18T10:12:00',
      modifiedAt: '2026-05-18T10:12:00',
      useStatus: 'Y',
    },
    {
      ownerSupplierId: 4,
      ownerSupplierName: '[e2e] 바다수산',
      ownerSupplierCode: 'SU000004',
      createdAt: '2026-05-11T09:00:00',
      modifiedAt: '2026-05-15T17:40:00',
      useStatus: 'Y',
    },
    {
      ownerSupplierId: 3,
      ownerSupplierName: '[e2e] 이름이 아주 긴 공급사명으로 말줄임 표시를 확인하기 위한 공급사',
      ownerSupplierCode: 'SU000003',
      createdAt: '2026-04-30T14:20:00',
      modifiedAt: '2026-05-02T08:05:00',
      useStatus: 'Y',
    },
    {
      ownerSupplierId: 2,
      ownerSupplierName: '[e2e] 한우목장',
      ownerSupplierCode: 'SU000002',
      createdAt: '2026-03-02T11:00:00',
      modifiedAt: '2026-03-02T11:00:00',
      useStatus: 'Y',
    },
    {
      ownerSupplierId: 1,
      ownerSupplierName: '[e2e] 제주감귤농원',
      ownerSupplierCode: 'SU000001',
      createdAt: '2026-01-05T09:30:00',
      modifiedAt: '2026-02-10T13:15:00',
      useStatus: 'Y',
    },
  ],
};

registerMockAPI<TypeGetOwnerSupplierResponse>({
  method: 'get',
  endpoint: '/api-owner/owner-supplier',
  label: '화주사정보/공급사관리/공급사목록',
  scenarios: [
    { name: '정상 응답 — 5건', response: ownerSupplierListResponse },
    { name: '검색 결과 0건', response: { pagination: { cursor: 1, listView: 50, listTotal: 0 }, data: [] } },
  ],
});
